import React, { PureComponent } from 'react';

import Notification from './Notification';
import notifSystem from '../../notifSystem';

class Notifications extends PureComponent {
  waitNotif = false;
  closeHandlers = new Map();
  state = {
    notifs: [],
  };
  componentDidMount() {
    this.unsubscribe = notifSystem.subscribe(this.incomingNotif);
    this.unsubscribeClose = notifSystem.subscribeClose(this.handleClose);
    this.readNotif();
  }
  componentWillUnmount() {
    this.unsubscribe();
    this.unsubscribeClose();
  }

  incomingNotif = () => {
    if (this.waitNotif) {
      this.readNotif();
    }
  };

  removeNotif = id => {
    this.closeHandlers.delete(id);
    this.setState(
      (prevState) => ({
        notifs: prevState.notifs.filter((e) => e.id !== id),
      }),
      this.readNotif
    );
  }

  registerClose = (id, closeFn) => {
    this.closeHandlers.set(id, closeFn);
  };

  unregisterClose = (id) => {
    this.closeHandlers.delete(id);
  };

  // Ferme (avec animation) les notifs correspondant au prédicat, en
  // réutilisant le chemin de fermeture manuel (closeComponent -> onExit ->
  // removeNotif). Cohérent avec le clic croix / clic action.
  handleClose = (predicate) => {
    this.state.notifs
      .filter(predicate)
      .forEach((n) => this.closeHandlers.get(n.id)?.());
  };

  readNotif = () => {
    this.waitNotif = false;
    this.setState((prevState) => {
      let notifs = prevState.notifs;
      let hasNotif = true;
      while (notifs.length < 5 && hasNotif) {
        const notif = notifSystem.consume();
        if (notif !== undefined) {
          notifs = [...notifs, notif];
        } else {
          hasNotif = false;
        }
      }
      if (hasNotif === false) {
        this.waitNotif = true;
      }
      return { notifs };
    });
  }

  render() {
    const { notifs } = this.state;
    const isConv = window.location.pathname === '/conversations';
    if (isConv) {
      return <></>;
    }

    return (
      <>
        <div
          style={{
            position: 'absolute',
            bottom: 32,
            left: 32,
            zIndex: 1301
          }}
        >
          {notifs
            .filter((e) => !['sms', 'email', 'popUp'].includes(e.type.name))
            .map((e) => (
              <Notification
                message={e}
                key={e.id}
                removeNotif={this.removeNotif}
                registerClose={this.registerClose}
                unregisterClose={this.unregisterClose}
              />
            ))}
        </div>
        <div
          style={{
            position: 'absolute',
            bottom: 50,
            right: 70,
            zIndex: 1500
          }}
        >
          {notifs
            .filter((e) => ['sms', 'email', 'popUp'].includes(e.type.name))
            .map((e) => (
              <Notification
                message={e}
                key={e.id}
                removeNotif={this.removeNotif}
                registerClose={this.registerClose}
                unregisterClose={this.unregisterClose}
              />
            ))}
        </div>
      </>
    );
  }
}

export default Notifications;
